export const FETCH_FILTER_SITES_REQUEST = '@filter/FETCH_FILTER_SITES_REQUEST';
export const FETCH_FILTER_SITES_SUCCESS = '@filter/FETCH_FILTER_SITES_SUCCESS';
export const FETCH_FILTER_SITES_FAILURE = '@filter/FETCH_FILTER_SITES_FAILURE';
export const FETCH_FILTER_SITES_CANCEL = '@filter/FETCH_FILTER_SITES_CANCEL';

export const SELECT_SITE_OPTION = '@filter/SELECT_SITE_OPTION';
export const CLEAR_SITE_OPTION = '@filter/CLEAR_SITE_OPTION';
